<div class="input-grid-gaps grid-5col">
  <div class="fr-3 grid-2col input-grid-gaps">
    <app-date-input [form]="form" id="dateFrom"></app-date-input>
    <app-date-input [form]="form" id="dateTo"></app-date-input>
  </div>
  <div class="fr-2">
    @if (form.get('dateFrom')?.value && form.get('dateTo')?.value) {
      <app-diagnosis-select-input
        [form]="form"
        [multiselect]="true"
        id="diagnoses"
        [label]="prefix + 'inputs.diagnoses'"
      ></app-diagnosis-select-input>

    }
  </div>
  <div [formGroup]="form" class="fr-1 grid-1col input-grid-gaps">
    <app-check-input [form]="form" id="anamnesis"
    [label]="prefix + 'inputs.anamnesis'"></app-check-input>
    <app-check-input [form]="form" id="diagnose"
    [label]="prefix + 'inputs.diagnose'"></app-check-input>
    <app-check-input [form]="form" id="bloodType"
    [label]="prefix + 'inputs.bloodType'"></app-check-input>
    <app-check-input [form]="form" id="medication"
    [label]="prefix + 'inputs.medication'"></app-check-input>
    <app-check-input [form]="form" id="allergy"
    [label]="prefix + 'inputs.allergy'"></app-check-input>
    @if (works.length) {
      <app-check-input [form]="form" id="dekurs"
      [label]="prefix + 'inputs.dekurs'"></app-check-input>
      <div class="grid-1col input-grid-gaps" [style]="{ paddingLeft: '1rem' }" formArrayName="dekurses">
        @for (control of form.controls.dekurses.controls; track control; let i = $index) {
          <div>
            <app-check-input
              [form]="control"
              id="selected"
              [label]="control?.value?.date | date: 'd.M.y'"
            ></app-check-input>
          </div>
        }
      </div>
    }
  </div>

  <div class="fr-4">
    <app-input-wysiwyg
      [form]="form"
      id="content"
      editorKey="MedicalReportCreateContent"
      [autocompleteOrganization]="true"
    ></app-input-wysiwyg>
  </div>
</div>

<div #dialogFooter class="p-dialog-footer">
  <app-cancel-button (clickEvent)="dialogRef.close()"></app-cancel-button>
  @if (store.isAllowed('doctorWork.create')()) {
    <app-save-button
      [loading]="processing"
      [disabled]="processing"
      (clickEvent)="save()"
    ></app-save-button>
    <app-button
      label="common.saveAndPrint"
      icon="pi-print"
      [loading]="processing"
      [disabled]="processing"
      (clickEvent)="print()"
    ></app-button>
  }
</div>
